import "styles/inputs/selectOneTile.less";
import React from "react";

interface SelectOneTileProps {
    index: number;
    inputId: string;
    options: { label: string; value: string; showOption: boolean; icon?: string; description?: string }[];
    value: string;
    onChange: (_value: string) => void;
    handleKeyDown?: (_event: any) => void;
    error?: string;
    suffix?: string;
}

const SelectOneTile: React.FC<SelectOneTileProps> = ({ options, value, onChange }) => {
    return (
        <div className="select-one-tile">
            {options.map((option, index) =>
                (option.showOption ? (
                    <div
                        key={index}
                        className={`select-one-tile__tile ${value === option.value ? "selected" : ""}`}
                        onClick={() => onChange(option.value)}
                    >
                        {option.icon && (
                            <img
                                src={option.icon}
                                alt={option.label}
                                className="select-one-tile__icon"
                            />
                        )}
                        <div className="flex-column">
                            <div className="select-one-tile__title">{option.label}</div>
                            <div className="select-one-tile__description">{option.description}</div>
                        </div>
                    </div>
                ) : null)
            )}
        </div>
    );
};

export default SelectOneTile;
